// extracted by mini-css-extract-plugin
module.exports = {"link":"TextLink_link__1ygSS","link_pc":"TextLink_link_pc__2neH-","link_sp":"TextLink_link_sp__rupgK"};